import React from 'react'
import { Action } from '../../../constants/Common'
import { ucFirst } from '../../../helpers/string_helper'
import CreatorDetails from '../../../pages/ChangeRequest/activities/creatorDetails'
import { withTranslation } from 'react-i18next'
function MilestoneBudget({item, t}) {
  return (
    <div><strong>{t('Milestone Budget')} ({item?.payload?.budgetType})</strong> {t('was associated with the')} <strong>{t('milestone')} ({item?.payload?.milestone?.name})</strong> {item.event === Action.CREATE ? t("was added with") : t("was deleted from")} {t('planned cost')} <strong>{item?.payload?.plannedCost}</strong> {t('under')} <strong>{t('startup')} {ucFirst(item.project.name)} ({item?.project?.uniqueProjectId})</strong> {t('by')} 
    <CreatorDetails creator={item?.creator} date={item?.createdAt} /></div>
  )
}
export default withTranslation()(MilestoneBudget)